import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/image/icon/icon_hint@2x.png'
import _imports_1 from '@/assets/image/vipImg/icon_success.png'
import _imports_2 from '@/assets/image/icon/icon_warn@2x.png'
import _imports_3 from '@/assets/image/vipImg/member_lip1.png'
import _imports_4 from '@/assets/image/vipImg/member_lip2.png'
import _imports_5 from '@/assets/image/vipImg/member_lip3.png'
import _imports_6 from '@/assets/image/vipImg/member_lip4.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "dialog-tip closeAuto",
  style: {"padding":"20px"}
}
const _hoisted_6 = { style: {"color":"#EB4545","font-weight":"500"} }
const _hoisted_7 = { style: {"margin-top":"10px"} }
const _hoisted_8 = {
  class: "flex-ter-bwn",
  style: {"margin-top":"20px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "orange-line--l" }, null, -1)
const _hoisted_10 = {
  class: "flex-ter",
  style: {"color":"#F18C3B"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"height":"16px","margin-right":"6px"}
}, null, -1)
const _hoisted_12 = { style: {"font-size":"16px","font-weight":"600"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {"height":"16px","margin-left":"6px"}
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "orange-line--r" }, null, -1)
const _hoisted_15 = {
  class: "flex member-lip",
  style: {"margin-top":"10px","background":"#F7F7F7","border-radius":"8px","padding":"20px","text-align":"center"}
}
const _hoisted_16 = { class: "fx-1 flex-ter-col" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_18 = { class: "member-lip-title" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"13px"} }, null, -1)
const _hoisted_20 = { class: "fx-1 flex-ter-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_22 = { class: "member-lip-title" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"13px"} }, null, -1)
const _hoisted_24 = { class: "fx-1 flex-ter-col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_26 = { class: "member-lip-title" }
const _hoisted_27 = {
  key: 0,
  style: {"width":"13px"}
}
const _hoisted_28 = {
  key: 1,
  class: "fx-1 flex-ter-col"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_30 = { class: "member-lip-title" }
const _hoisted_31 = { style: {"margin-top":"20px"} }
const _hoisted_32 = { style: {"color":"#EB4545"} }
const _hoisted_33 = {
  key: 3,
  class: "dialog-tip"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  class: "paypal-tip"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  class: "flex-ter-cen-col",
  style: {"padding-bottom":"20px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { t } from '@/plugins/i18n'
import { computed, ref, watch, nextTick } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { useRtfix, isJA, useSite } from '@/store'
import AskDialog from './AskDialog.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  isPaypal: {
    type: Boolean,
    default: false
  },
  isAuto: {
    type: Number,
    default: 1
  }
},
  emits: ['update:visible', 'submit', 'reload'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()

const userInfo = computed(() => store.getters.membership)


const openAsk = ref(false)

watch(openAsk, (v) => {
  const el = document.querySelector('.pay-confirm-dialog') as HTMLElement
  v ? (el.style.height = '0px') : setTimeout(() => {
    el && (el.style.height = 'auto')
  }, 300)
})

// 第二个弹框关闭
const submit = () => {
  openAsk.value = false
  emit('update:visible', false)
  nextTick(() => {
    emit('submit')
  })
}


const close = () => {
  openAsk.value = false
  emit('update:visible', false)
  if (props.isAuto === 2) {
    const el = document.querySelector('.pay-confirm-dialog') as HTMLElement
    el.style.height = '0px'

    nextTick(() => {
      emit('reload')
      setTimeout(() => {
        const el = document.querySelector('.pay-confirm-dialog') as HTMLElement
        el.style.height = 'auto'
      }, 200)
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "pay-confirm-dialog",
    "model-value": __props.visible,
    top: "7vh",
    onClose: close,
    draggable: "",
    width: __props.isAuto === 1 ? '600px' : '500px',
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.isAuto === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(t)('请注意')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["dialog-title", _unref(useSite)()])
            }, [
              _hoisted_4,
              _createTextVNode(_toDisplayString(_unref(t)('已为您开启自动续费')), 1)
            ], 2)),
        (__props.isAuto === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('您已选择关闭自动付款')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('★请再次确认★')), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('[推荐设置！ 超过90%的用户设定]')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(_unref(t)("我们建议您自动支付支付每月的会员费。")), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(t)('*如果自动付款设置为“关闭”，则需要采取以下措施。')), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(t)('① 每月需要缴纳会费工作')), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(t)('（2）如果会员有效期满而未采取第（1）项中的措施，则将无法使用所有会员服务。')), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(t)('→需再次办理入会手续')), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('不可续费功能，超过有效期后无法使用')), 1),
                  _hoisted_13
                ]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('KAERU工具')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('· 直接从中国EC网站购买购物车')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('日语和图片产品搜索')), 1)
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('产品订单')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('· 直接采购中国产品，最高品质检验')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('·行业最快的物流服务')), 1)
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('発送')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('最快、最便宜的国际运输')), 1)
                ]),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                  : _createCommentVNode("", true),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('API連携')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('· 与其他网站（BASE、shopify、亚马逊等）的链接')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('· 自动下单、批量产品注册、FBA发货等')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createTextVNode(_toDisplayString(_unref(t)('如果取消自动付款，过期后将不会自动续充会员')) + " ", 1),
                _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('您的订单将自动停止处理，这可能会导致交货延迟。')), 1),
                _createTextVNode(" " + _toDisplayString(_unref(t)('您确定要关闭会员费自动续费功能吗？')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", {
                class: "tip1",
                innerHTML: _unref(t)('已为您开启V自动续费，记得保持余额充足。').replace('V', `<span style='color:#EB4545;'>【${_unref(userInfo).membershipTemplateName}】</span>`)
              }, null, 8, _hoisted_34),
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _hoisted_37,
                    _createElementVNode("span", {
                      innerHTML: _unref(t)('为了能正常打开自动续费，请务必前往PayPal开启自动续费。')
                    }, null, 8, _hoisted_38)
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]),
      _createElementVNode("div", _hoisted_39, [
        (__props.isAuto === 1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              class: "btn",
              style: {"margin-bottom":"10px"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('保留自动续费')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_40,
        _createVNode(_component_el_button, {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.isAuto === 1 ? (openAsk.value = true) : close()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.isAuto === 1 ? _unref(t)('关闭自动续费') : _unref(t)('知道了')), 1)
          ]),
          _: 1
        })
      ]),
      (openAsk.value)
        ? (_openBlock(), _createBlock(AskDialog, {
            key: 0,
            visible: openAsk.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (close())),
            onSubmit: submit
          }, null, 8, ["visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "width"]))
}
}

})